import { put, call, takeLatest, delay, select } from "redux-saga/effects";
import { ErrorHandler } from "../../utils/errorHandler";
import * as actions from "./actions";
import {
  updateBanners,
  deleteBanner,
  GetBanners_cards,
  createBanners,
} from "./services";

function* __GET_BANNERS(action) {
  try {
    var payload = {
      banners: [],
    };
    const res = yield GetBanners_cards();
    const data = res?.data;
    payload.banners = data;
    yield put(actions.create_Banners_success(payload));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.create_Banners_fail({ error: errorMessage }));
  }
}

export function* GetBannersCards() {
  yield takeLatest(actions.GET_BANNERS, __GET_BANNERS);
}

function* __CREATE_BANNERS(action) {
  try {
    let payload = action.payload;
    const res = yield createBanners(payload);
    if (res) {
      action.payload.success(payload);
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
    yield put(actions.create_Banners_fail({ error: errorMessage }));
  }
}

export function* create_Banner() {
  yield takeLatest(actions.CREATE_BANNERS, __CREATE_BANNERS);
}

//delete banners
function* __DELETE_BANNERS(action) {
  try {
    const res = yield deleteBanner(action.payload.banner_id);
    const data = res?.data;

    yield put(actions.get_Banners());
    action.payload.success(data);
  } catch (e) {
    console.log({ e });
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
  }
}

export function* delBanners() {
  yield takeLatest(actions.DELETE_BANNER, __DELETE_BANNERS);
}

//edit Banners

function* __UPDATE_BANNERS(action) {
  try {
    let payload = action.payload.data;
    const res = yield updateBanners(payload.id);
    if (res) {
      action.payload.success(payload);
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.error(errorMessage);
    yield put(actions.create_Banners_fail({ error: errorMessage }));
  }
}

export function* updateBannersCards() {
  yield takeLatest(actions.UPDATE_BANNERS, __UPDATE_BANNERS);
}
